import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import About from './Pages/About';
import Services from './Pages/Services';
import Portfolio from './Pages/Portfolio';
import Contact from './Pages/Contact';
import Header from './components/Header';
import Footer from './Pages/Footer';
import './assets/styles/base.css';
import './assets/styles/animations.css';
import Home from "./Pages/Home"
import ShopSection from "./components/ShopSection";
import MainPortfolio from "./Pages/MainPortfolio";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import Dashboard from "./Pages/Dashboard";
import TrainingModule from "./Pages/TrainingModule";
import Statistics from "./Pages/Statistics";
import LedgerSystem from "./Pages/LedgerSystem";
import Testimonials from "./Pages/Testimonials";
import CeoDashboard from "./Pages/CeoDashboard";
import ProjectManagementDashboard from "./components/ProjectManagement/ProjectManagementDashboard";
import Welcome from "./Pages/Welcome";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          {/* Routes WITH Header and Footer */}
          <Route path="/*" element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/catalog" element={<Portfolio />} />
                <Route path="/portfolio" element={<MainPortfolio />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/testimonials" element={<Testimonials/>} />
                <Route path="/shop" element={<ShopSection />} />
              </Routes>
              <Footer />
            </>
          } />
          
          {/* Routes WITHOUT Header and Footer */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/welcome" element={<Welcome />} />

          
          {/* SINGLE TRAINING ROUTE FOR ALL MODULES */}
          <Route path="/training/:moduleId" element={<TrainingModule />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/ledgersystem" element={<LedgerSystem/>} />
          <Route path="/financialanalysis" element={<CeoDashboard/>} />
          <Route path="/projectmanagement" element={<ProjectManagementDashboard/>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;